var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPckeepStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#690048"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.432 42.501H32.74a4.878 4.878 0 00-4.879 4.879v82.416a4.878 4.878 0 004.879 4.879h134.692a4.878 4.878 0 004.879-4.879V47.38a4.88 4.88 0 00-4.879-4.879zm-67.346 4.766a1.605 1.605 0 110 3.21 1.605 1.605 0 010-3.21zm60.043 73.478c0 .783-.635 1.418-1.418 1.418H41.462a1.418 1.418 0 01-1.418-1.418V56.432c0-.783.635-1.418 1.418-1.418H158.71c.783 0 1.418.635 1.418 1.418v64.313zM187.025 140.53H12.986c-.37 0-.669.3-.669.669 0 9.002 7.298 16.299 16.299 16.299h142.768c9.002 0 16.299-7.297 16.299-16.299v-.011a.657.657 0 00-.658-.658zm-76.855 11.584H89.938a3.1 3.1 0 010-6.2h20.232a3.1 3.1 0 010 6.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPckeepStyle);
export default __webpack_public_path__ + "static/media/pc.keepStyle.9a80229681cc7a8ffc9e48a81a1d671d.svg";
export { ForwardRef as ReactComponent };